import DashboardIcon from "./assets/sidebar-icons/dashboard.svg";
import CategoriesIcon from "./assets/sidebar-icons/categories.svg";
import CampusesIcon from "./assets/sidebar-icons/campus.svg";
import VendorsIcon from "./assets/sidebar-icons/vendors.svg";
import ItemsIcon from "./assets/sidebar-icons/items.svg";
import CentralInventoryIcon from "./assets/sidebar-icons/inventroy1.svg";
import CampusInventoryIcon from "./assets/sidebar-icons/inventroy2.svg";
import AllInventoriesIcon from "./assets/sidebar-icons/inventroy3.svg";
import CampusAllotmentsIcon from "./assets/sidebar-icons/campus-allotments.svg";
import AllAllotmentsIcon from "./assets/sidebar-icons/all-allotments.svg";
import RequestsIcon from "./assets/sidebar-icons/request.svg";
import RolesIcon from "./assets/sidebar-icons/roles.svg";
import UsersIcon from "./assets/sidebar-icons/users.svg";
import ReportsIcon from "./assets/sidebar-icons/reports.svg";
import ActivityLogIcon from "./assets/sidebar-icons/activity-log.svg";
import SettingsIcon from "./assets/sidebar-icons/settings.svg";
import LogoutIcon from "./assets/sidebar-icons/logout.svg";

export const SIDEBAR_NAVITEMS = [
  { name: "Dashboard", route: "/", icon: DashboardIcon, routeKey: "dashboard" },
  {
    name: "Categories",
    route: "/categories",
    icon: CategoriesIcon,
    routeKey: "category_management",
  },
  {
    name: "Campuses",
    route: "/campuses",
    icon: CampusesIcon,
    routeKey: "campus_management",
  },
  {
    name: "Vendors",
    route: "/vendors",
    icon: VendorsIcon,
    routeKey: "vendor_management",
  },
  { name: "Items", route: "/items", icon: ItemsIcon, routeKey: "item_management" },
  {
    name: "Central Inventory",
    route: "/central-inventory",
    icon: CentralInventoryIcon,
    routeKey: "central_inventory",
  },
  {
    name: "Campus Inventory",
    route: "/campus-inventory",
    icon: CampusInventoryIcon,
    routeKey: "campus_inventory",
  },
  {
    name: "All Inventories",
    route: "/all-inventories",
    icon: AllInventoriesIcon,
    routeKey: "all_campuses_inventories",
  },
  {
    name: "Campus Allotments",
    route: "/campus-allotments",
    icon: CampusAllotmentsIcon,
    routeKey: "stock_allotment",
  },
  {
    name: "All Allotments",
    route: "/all-allotments",
    icon: AllAllotmentsIcon,
    routeKey: "all_campuses_stock_allotment",
  },
  {
    name: "Requests",
    route: "/requests",
    icon: RequestsIcon,
    routeKey: "all_requests",
  },
  {
    name: "Campus Requests",
    route: "/campus-requests",
    icon: RequestsIcon,
    routeKey: "campus_requests",
  },
  { name: "Roles", route: "/roles", icon: RolesIcon, routeKey: "role_management" },
  { name: "Users", route: "/users", icon: UsersIcon, routeKey: "user_management" },
  {
    name: "Activity Log",
    route: "/activity-log",
    icon: ActivityLogIcon,
    routeKey: "activity_logs",
  },
  {
    name: "Settings",
    route: "/settings",
    icon: SettingsIcon,
    routeKey: "settings",
  },
];
